import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

/**
 * 그룹 과정 선택 목록/칩에 과정명, 언어, 유료·무료, 훈련 필요 여부를 함께 표시한다.
 */

const CourseSelectLabel = ({ course }) => {
  if (!course) return null;
  const isFree = Boolean(course.freeYn);
  const feeLabel = isFree ? '무료' : '유료';
  const needsTraining = Boolean(course.hasTraining);
  const trainingLabel = needsTraining ? '훈련 필요' : '훈련 불필요';

  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      <Typography variant="body2" component="span">
        {course.courseName || `과정 ID: ${course.courseId}`}
      </Typography>
      <Chip
        label={feeLabel}
        size="small"
        variant="outlined"
        color={isFree ? 'default' : 'warning'}
      />
      <Chip
        label={trainingLabel}
        size="small"
        variant="outlined"
        color={needsTraining ? 'error' : 'default'}
      />
    </Stack>
  );
};

export default CourseSelectLabel;
